function Navbar() {
    return (
        <nav className = "navbar navbar-dark bg-dark px-4">
            <span className="navbar-brand mb-0 h1">
                TaskFlow Team Manager
            </span>
        </nav>
    )
}

export default Navbar;